import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import NuoYun from "./components"; //导入js
import animated from 'animate.css'
import "./assets/css/public/descriptionsStyle.less"
import "vue-cropper/dist/index.css"


import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'






const app = createApp(App);
app.config.productionTip = false;
// 添加全局错误处理,解决内容区域出现错误后，导至菜单功能失效
app.config.errorHandler = (err) => {
    console.error(err)
}

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    // if (to.meta.title) {
    //     document.title = to.meta.title;
    // }
    next();
});


app
    .use(animated)
    .use(store)
    .use(ElementPlus)
    .use(router)
    .use(NuoYun)
    .mount('#app')



